import { DebugHelper } from "@/helper/debugHelper";
import { StringHelper } from '@/helper/stringHelper';

export class ZipCompressor
{
    private zip;

    constructor()
    {
        var zip = require('zlibjs/bin/zip.min').Zlib.Zip;
        this.zip = new zip();
    }

    public addFile(filename : string, buffer : Uint8Array)
    {
        DebugHelper.trace(filename);
        try
        {
            var filenameBuffer = StringHelper.strToUtf8Array(filename);
            this.zip.addFile(buffer, { filename : filenameBuffer });
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    public compressFiles() : Uint8Array | null
    {
        var compressed : Uint8Array | null = null;
        try
        {
            compressed = this.zip.compress();
        }
        catch(e)
        {
            DebugHelper.trace(e);
            compressed = null;
        }

        return compressed;
    }

    public dispose()
    {
        this.zip = null;
    }
}